import { useContext, useEffect } from "react";
import { getChargeButtonTitle } from "../../../../utils";
import { Box } from "@mui/material";
import { ReactComponent as OnlinePaymentIcon } from "./../../../../assets/icons/online_payment_icon.svg";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import "./styles.css";

export default function OnlinePaymentCheckOut({
  totalAmount,
  confirmSale,
  isLoadingbtn = false,
}) {
  const [I18n] = useContext(LanguageContext);

  useEffect(() => {
    triggerLogEvent(analytics, "pos_online_payment_start", {
      total_amount: totalAmount,
    });
  }, []);

  const handleConfirmSale = () => {
    triggerLogEvent(analytics, "pos_online_payment_confirmed", {
      total_amount: totalAmount,
    });
    confirmSale();
  };

  return (
    <Box
      flex={1}
      className="h-100 w-100"
      display={"flex"}
      flexDirection={"column"}
    >
      <Box></Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width={"100%"}
        flex={11}
      >
        <Box mb={"0.63rem"}>
          <ParagraphText
            className={`fontWeight400 fontSize14 newFontColor`}
            style={{ lineHeight: "22px" }}
          >
            {I18n.bill_amount}
          </ParagraphText>
        </Box>
        <Box mb={"1.5rem"}>
          <ParagraphText
            className={`fontWeight600 newFontColor fontSize32`}
            style={{ lineHeight: "40px" }}
          >
            Rs. {formatNum(totalAmount)}
          </ParagraphText>
        </Box>

            <Box mb={"0.63rem"}>
              <ParagraphText
                style={{ lineHeight: "22px" }}
                className={`fontWeight500 fontSize16 newLightColor`}
              >
                {I18n.online_payment_checkout}
              </ParagraphText>
            </Box>

      </Box>
      <Box flex={1}>
        <UBButton
          id="pos_charge_btn"
          disabled={isLoadingbtn}
          title={getChargeButtonTitle(I18n, totalAmount)}
          className={`charges-amount-btn active`}
          onClick={handleConfirmSale}
        />
      </Box>
    </Box>
  );
}
